import Dashboard from "components/dashboard/Dashboard";
import CompanyIndex from "components/companyList/Index";
import MachineIndex from "components/machineList/Index";
import OilIndex from "components/oilList/Index";
import UserIndex from "components/userList/Index";
import MonthDayReport from "components/monthDayReport/MonthDayReport";
import dashboardIcon from './assets/img/dashboard.png'
import userListIcon from './assets/img/user.png'
import companyListIcon from './assets/img/company.png'
import oilListIcon from './assets/img/oil.png'
import machineListIcon from './assets/img/machine.png'
import reportIcon from './assets/img/report.png'
import libIcon from './assets/img/lib.png'
import Library from "components/library/Library";
import adminSettingIcon from './assets/img/setting.png'
import AdminSetting from "components/adminSettings/AdminSetting";

//routing management 
let routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: dashboardIcon,
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    path: "/user-management",
    name: "User Master",
    icon: userListIcon,
    component: <UserIndex />,
    layout: "/admin",
  },
  {
    path: "/company-management",
    name: "Company Master",
    icon: companyListIcon,
    component: <CompanyIndex />,
    layout: "/admin",
  },
  {
    path: "/oil-management",
    name: "Oil Master",
    icon: oilListIcon,
    component: <OilIndex />,
    layout: "/admin",
  },
  {
    path: "/machine-management",
    name: "Machine Master",
    icon: machineListIcon,
    component: <MachineIndex />,
    layout: "/admin",
  },
  {
    path: "/report",
    name: "Report",
    icon: reportIcon,
    component: <MonthDayReport />,
    layout: "/admin",
  },
  {
    path: "/library",
    name: "Resources",
    icon: libIcon,
    component: <Library />,
    layout: "/admin",
  },
  {
    path: "/setting",
    name: "Admin Settings",
    icon: adminSettingIcon,
    component: <AdminSetting />,
    layout: "/admin",
  }
];
export default routes;
